import { AlertTriangle } from "lucide-react";
import { Modal } from "./Modal";
import { Button } from "../Button";

/**
 * Destructive-action confirmation. No mutation in the app should run without
 * routing through this (see docs/ux.md §5).
 */
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = "Confirmer l'action",
  message,
  confirmLabel = "Confirmer",
  destructive = true,
  loading,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmLabel?: string;
  destructive?: boolean;
  loading?: boolean;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth={400}
      title={
        <span className={destructive ? "text-danger flex items-center gap-2" : "flex items-center gap-2"}>
          {destructive && <AlertTriangle className="h-4 w-4" />}
          {title}
        </span>
      }
      footer={
        <>
          <Button variant="ghost" size="sm" onClick={onClose} disabled={loading}>
            Annuler
          </Button>
          <Button variant={destructive ? "danger" : "primary"} size="sm" onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-[13px] text-text">{message}</p>
      {destructive && (
        <div className="mt-4 rounded-sm border border-danger/30 bg-danger-dim px-3 py-3">
          <p className="text-[12px] text-danger">
            Cette action archive l'élément (soft delete). Il pourra être restauré.
          </p>
        </div>
      )}
    </Modal>
  );
}
